// k3s-development build target (Story 37.16) — the in-cluster nginx image
// for the dev k3s stack (consolidated single-hostname model, FR19).
//
// The DEPLOYED bundle is origin-agnostic: `resolveApiBase()` (Story 27.9)
// uses `window.location.origin` on any non-localhost host, so the SPA is
// same-origin with the API on the k3s validation host today and on the
// canonical host after the 37.20 cutover with NO rebuild. `authUrl` below is
// therefore the localhost-only fallback (ng serve / karma), same as the
// `development` configuration.
export const environment = {
    authUrl: "https://auth.development.emjo-consulting.dk",
    appName: "Emjo OAuth",
    recaptchaSiteKey: '6LcDrv4sAAAAAPnZZjh6DZNrts9K4PlUpWkaD9SE' //gitleaks:allow -- public reCAPTCHA site key (shipped to browser)
};
